<div class="container">
  <button mat-icon-button (click)="back()">
    <mat-icon>arrow_back</mat-icon>
  </button>
</div>
